import { combineReducers } from 'redux'
import { areasReducer as areas, areaReducer as area } from './project/areasReducer'
import { projectReducer as project } from './project/projectReducer'
import { mobilityReducer as mobility } from './report/mobilityReducer'

export default combineReducers({
  area,
  areas,
  project,
  mobility,
})
